export const BaseConfig = {
  width: 18,
  height: 18,
  fill: 'gray',
  strokeWidth: 1,
  stroke: 'gray',
  strokeOpacity: 1,
};
